<template>
  <div class="modal-title with-logo">
    <h3>Hoe ging je aanmelding bij {{ frankStore.product.provider_name }}?</h3>
  </div>

  <div class="button-container component-spacing-top">
    <ButtonIconLeft
      type="cta"
      icon="thumbs-up"
      label="Tevreden"
      @click="frankStore.positiveFlow()"
    />

    <ButtonIconRight
      icon="x-fa-thumbs-down"
      type="cta"
      label="Kon beter"
      @click="frankStore.negativeFlow()"
    />
  </div>

  <div class="link-container component-spacing-top">
    <LinkIconRight
      icon="x-fa-search"
      label="Ik ben nog gaan het zoeken"
      @click="frankStore.closeFrank()"
    />
    <LinkIconRight
      icon="x-fa-envelope"
      label="Mail deze vergelijking"
      @click="saveComparison"
    />
  </div>
</template>

<script setup>
import { useFrankStore } from './store/frankStore';
import ButtonIconRight from '../../../abstracts/elements/button/icon-right/button-icon-right.vue';
import ButtonIconLeft from '../../../abstracts/elements/button/icon-left/button-icon-left.vue';
import LinkIconRight from '../../../abstracts/elements/link/icon-right/link-icon-right.vue';

const frankStore = useFrankStore();

const emit = defineEmits(['save']);

const saveComparison = () => {
    frankStore.closeFrank();
    emit('save');
};

</script>
